import React, { useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography, Divider, List, ListItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import HeaderPopup, { useHeaderPopupStyles } from "./headerPopupNew";
import * as TaskActions from "../../../redux/task/taskActions";
import { WorkOrderActionIcon } from "../../common/icons/workOrderStatusIconHelper";
import { STATUSES, FOLLOW_UP } from "../../../globals/workOrderStatus";
import { useLocalizedName } from "../../../globals/langHelpers";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const messages = defineMessages({
    closeTooltip: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
});

const useStyles = makeStyles((theme) => ({
    superTitle: {
        color: "var(--text-white)",
        fontFamily: "Arial",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "14px",
        textAlign: "left",
        display: "block",
    },
    title: {
        color: "var(--text-dark)",
        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "22px",
        textAlign: "left",
        display: "block",
    },
    statusHeader: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "13.8px",
        letterSpacing: "-0.15px",
        textAlign: "left",
        marginTop: "22px",
        display: "block",
    },
    closeButton: {
        position: "absolute",
        right: "0px",
        top: "4px",
        color: "var(--text-white)",
    },
}));

export const Actions = (props) => {
    const { workorderData, isAdmin = false, onInComplete, jobActions, onRemove, login, onComplete, relatedIdInformation } = props;
    const classes = useStyles();
    const popupClasses = useHeaderPopupStyles();
    const history = useHistory();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();

    // keep an instance of the popup component
    // so we can close when a user clicks on an action
    const popupRef = useRef(null);

    const closePopup = () => {
        if (popupRef.current !== null) {
            popupRef.current.close();
        }
    };

    const status =
        workorderData && workorderData.status
            ? workorderData?.status
            : {
                  id: 0,
              };

    const disabled = {
        assigned: true,
        enroute: status.id !== STATUSES.ASSIGNED,
        onsite: status.id !== STATUSES.ENROUTE,
        complete: status.id !== STATUSES.ONSITE,
        incomplete: status.id !== STATUSES.ONSITE,
        unassigned:
            login?.keycloak?.hasRealmRole("ContractorAdminRole") === true
                ? ![STATUSES.ASSIGNED, STATUSES.INCOMPLETE].includes(status.id)
                : status.id !== STATUSES.INCOMPLETE,
    };

    const handelCompleteActionClick = () => {
        const hasCompletionCodeFlag = isAdmin ? workorderData.hasCompletionReasons : workorderData?.workActivity?.hasCompletionReasons;
        if (hasCompletionCodeFlag) {
            onComplete();
        } else {
            props.complete({ workOrderNumber: workorderData?.workOrderNumber, userName: props?.userInfo?.preferred_username });
            !isAdmin && history.push(`/workorderdetails/${workorderData.workOrderNumber}/complete`);
        }
        closePopup();
    };

    return (
        <HeaderPopup
            id="work-order-actions"
            ref={popupRef}
            customStyle={true}
            isAdmin={isAdmin}
            icon={(open) =>
                !isAdmin ? (
                    <WorkOrderActionIcon id={status.id} color={open ? "var(--blue-bell)" : "white"} />
                ) : (
                    <Button color="primary" endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                        <Typography className={classes.title}>{getLocalizedName({ object: status })}</Typography>
                    </Button>
                )
            }>
            <List aria-label="profile details" onClose={onRemove} style={{ paddingTop: 0 }}>
                <ListItem style={{ padding: 12, backgroundColor: "#00549A", borderRadius: "10px 10px 0 0" }}>
                    <div>
                        <Typography className={classes.superTitle}>
                            <FormattedMessage
                                id="work-order-actions.current-status-header"
                                defaultMessage="You are currently:"
                                description="Work order actions current status header"
                            />
                        </Typography>
                        <Typography className={classes.title} style={{ color: "white" }}>
                            {getLocalizedName({ object: status })}
                        </Typography>
                        <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={() => {
                                closePopup();
                            }}>
                            <CloseIcon title={intl.formatMessage(messages.closeTooltip)} />
                        </IconButton>
                    </div>
                </ListItem>
                <ListItem>
                    <Typography className={classes.statusHeader}>
                        <FormattedMessage
                            id="work-order-actions.change-status-header"
                            defaultMessage="CHANGE STATUS TO:"
                            description="Work order actions change status header"
                        />
                    </Typography>
                </ListItem>

                {!disabled.assigned ? (
                    <ListItem>
                        <button className={popupClasses.linkButton} type="button" onClick={() => {}} disabled={disabled.assigned}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.ASSIGNED}
                                color={disabled.assigned ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage id="work-order-actions.assigned" defaultMessage="Assigned" description="Work order assigned action" />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
                {!disabled.unassigned ? (
                    <ListItem>
                        <button
                            className={popupClasses.linkButton}
                            type="button"
                            onClick={() => {
                                props.unassigned(workorderData.workOrderNumber);
                                closePopup();
                            }}
                            disabled={disabled.unassigned}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.UNASSIGNED}
                                color={disabled.enroute ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage
                                id="work-order-actions.unassigned"
                                defaultMessage="Unassigned"
                                description="Work order unassigned action"
                            />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
                {!disabled.enroute ? (
                    <ListItem>
                        <button
                            className={popupClasses.linkButton}
                            type="button"
                            onClick={() => {
                                props.enroute(workorderData.workOrderNumber, false);
                                closePopup();
                            }}
                            disabled={disabled.enroute}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.ENROUTE}
                                color={disabled.enroute ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage id="work-order-actions.enroute" defaultMessage="En route" description="Work order enroute action" />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
                {!disabled.onsite ? (
                    <ListItem>
                        <button
                            className={popupClasses.linkButton}
                            type="button"
                            onClick={() => {
                                props.onsite(workorderData.workOrderNumber, false);
                                closePopup();
                            }}
                            disabled={disabled.onsite}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.ONSITE}
                                color={disabled.onsite ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage id="work-order-actions.onsite" defaultMessage="On site" description="Work order on site action" />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
                {!disabled.complete ? (
                    <ListItem>
                        <button className={popupClasses.linkButton} type="button" onClick={handelCompleteActionClick} disabled={disabled.complete}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.COMPLETE}
                                color={disabled.complete ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage id="work-order-actions.compete" defaultMessage="Complete" description="Work order compete action" />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
                {!disabled.incomplete ? (
                    <ListItem>
                        <button
                            className={popupClasses.linkButton}
                            type="button"
                            onClick={() => {
                                isAdmin ? onInComplete() : history.push(`/workorderdetails/${workorderData.workOrderNumber}/incomplete`);
                                closePopup();
                            }}
                            disabled={disabled.incomplete}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={STATUSES.CLOSED_INCOMPLETE}
                                color={disabled.incomplete ? "var(--inactive-color)" : "var(--blue-bell)"}
                            />
                            <FormattedMessage
                                id="work-order-actions.incomplete"
                                defaultMessage="Incomplete job"
                                description="Work order Incomplete Job action"
                            />
                        </button>
                    </ListItem>
                ) : (
                    ""
                )}
            </List>
            <Divider />
            {jobActions && process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                <>
                    <ListItem>
                        <Typography className={classes.statusHeader}>
                            <FormattedMessage
                                id="work-order-actions.job-actions-header"
                                defaultMessage="JOB ACTIONS"
                                description="Work order actions job actions header"
                            />
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <button
                            className={popupClasses.linkButton}
                            type="button"
                            //disabled={(disabled.complete || disabled.incomplete)}
                            disabled={true}
                            onClick={() => {
                                history.push(`/workorderdetails/${workorderData.workOrderNumber}/followUp`);
                            }}>
                            <WorkOrderActionIcon
                                className={popupClasses.icon}
                                id={FOLLOW_UP.CREATE_FOLLOW_UP}
                                color={"var(--inactive-color)"}
                                //color={(disabled.complete || disabled.incomplete) ? 'var(--inactive-color)' : 'var(--blue-bell)' }
                            />
                            <FormattedMessage
                                id="work-order-actions.createfollowup-header"
                                defaultMessage="Create Follow-up"
                                description="Work order actions Create follow-up button"
                            />
                        </button>
                    </ListItem>
                </>
            )}
        </HeaderPopup>
    );
};

const mapStateToProps = (state) => ({
    workorderData: state.tasks.workorderData.workorderData,
    login: state.login,
    userInfo: state.login.userInfo,
    relatedIdInformation: state.tasks.workorderData.relatedIdInformation,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            enroute: TaskActions.taskEnroute,
            onsite: TaskActions.taskOnsite,
            complete: TaskActions.taskComplete,
            unassigned: TaskActions.taskUnassign,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
